import React from 'react';
import './HeroSection.css';
import pinIcon from '../asset/icons/pin.svg';
import mailIcon from '../asset/icons/mail-icon.svg';
import eyeIcon from '../asset/icons/eye-icon.svg';
import heroImage from '../asset/images/sara-bocca-restauratrice.webp';
import waveDivider from '../asset/icons/wave-divider.svg';

const HeroSection = () => {
  return (
    <section className="hero-section">
      <div className="container hero-container">
        <div className="hero-text">
          <div className="hero-subtitle">
            <h2 className="subtitle-text">RESTAURO D'ARTE</h2>
            <div className="hero-badges">
              <div className="badge">
                <img src={pinIcon} alt="Location" className="badge-icon" />
                <span>Milano</span>
              </div>
              <div className="badge">
                <img src={pinIcon} alt="Location" className="badge-icon" />
                <span>Lombardia</span>
              </div>
              <div className="badge">
                <img src={pinIcon} alt="Location" className="badge-icon" />
                <span>Piemonte</span>
              </div>
            </div>
          </div>
          
          <div className="hero-title">
            <h1>Diamo nuova vita<br />ai tuoi <span className='hero-accent'>Tesori del Passato</span>,<br />insieme</h1>
            <p className="hero-description">
              Se stai cercando una professionista che si prenda cura del tuo patrimonio artistico con competenza e passione, sei nel posto giusto.
            </p>
          </div>
          
          <div className="hero-cta">
            <a href="#contact" className="btn btn-primary">
              <img src={mailIcon} className="btn-mail-icon" alt="Mail" />
              Richiedi un preventivo gratuito
            </a>
            <a href="#lavori" className="btn btn-secondary mobile-only">
              <img src={eyeIcon} alt="Eye" />
              Scopri i miei lavori
            </a>
          </div>
        </div>
        
        <div className="hero-image-container">
          <div className="hero-image">
            <div className="image-frame" style={{ backgroundImage: `url(${heroImage})` }}>
              {/* The actual image is set as background in inline style */}
            </div>
            <div className="decorative-circle circ-1"></div>
            <div className="decorative-circle circ-2"></div>
            <div className="decorative-circle circ-3"></div>
            <div className="decorative-circle circ-4"></div>
            <div className="decorative-circle circ-5"></div>
            <div className="decorative-circle circ-6"></div>
            <div className="decorative-circle circ-7"></div>
            <div className="decorative-circle circ-8"></div>
            <div className="decorative-circle circ-9"></div>
            <div className="decorative-circle circ-10"></div>
          </div>
        </div>
      </div>
      
{/*      <div className="scroll-indicator">
        <img src={arrowIcon} alt="Scroll down" />
      </div>
*/}
      
      <img src={waveDivider} alt="" className="hero-wave-divider" width="1280" height="249" />
    </section>
  );
};

export default HeroSection; 